import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Message} from 'src/app/core/class/message';
import {CommonService} from 'src/app/core/services/common.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'dowload-app-mobile',
  templateUrl: './dowload-app-mobile.component.html',
  styleUrls: ['./dowload-app-mobile.component.scss']
})
export class DowloadAppMobileComponent extends BaseComponent implements OnInit {
  isMySign = false;
  constructor(
    public dialogRef: MatDialogRef<DowloadAppMobileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.cancel();
    });
    if (data && data.isMySign) {
      this.isMySign = data.isMySign;
    } else {
      this.isMySign = false;
    }
  }

  urlDowload: string = 'https://hopdongdientu.viettel.vn/download-app';
  urlAppstore: string = 'https://apps.apple.com/vn/app/vcontract/id1611141207';
  urlChPlay: string = 'https://play.google.com/store/apps/details?id=com.viettel.vcontract';
  urlDowloadMysign: string = 'https://remotesigning.viettel.vn/mysignws/reg?code=';
  urlAppstoreMysign: string = 'https://apps.apple.com/vn/app/mysign/id1633019232';
  urlChPlayMysign: string = 'https://play.google.com/store/apps/details?id=com.viettel.cloud.ca.mysign';
  copyLink() {
    if(!this.isMySign) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.urlDowload).then(() => {
          this.toastr.success(
            this.message.getMessage("app_mobile.link_copied")
          );
        }).catch((error) => {
          console.error('Lỗi khi sao chép đường dẫn:', error);
        });
      } else {
        this.unsecuredCopyToClipboard(this.urlDowload);
      }
    }
    if(this.isMySign) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.urlDowloadMysign).then(() => {
          this.toastr.success(
            this.message.getMessage("app_mobile.link_copied")
          );
        }).catch((error) => {
          console.error('Lỗi khi sao chép đường dẫn:', error);
        });
      } else {
        this.unsecuredCopyToClipboard(this.urlDowloadMysign);
      }
    }
  }

  changeLinkStore(typeStore:string) {
    if (this.isMySign) {
      if (typeStore == 'AppStore') {
        window.open(this.urlAppstoreMysign, '_blank');
      } else {
        window.open(this.urlChPlayMysign, '_blank');
      }
    } else {
      if (typeStore == 'AppStore') {
        window.open(this.urlAppstore, '_blank');
      } else {
        window.open(this.urlChPlay, '_blank');
      }
    }
  }

  unsecuredCopyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      this.toastr.success(
        this.message.getMessage("app_mobile.link_copied")
      );
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  /**
   * Close pop-up
   */
  cancel() {
    this.dialogRef.close();
  }
}
